import { useContext, useState } from 'react'
import { invitacionAActivar } from '../avisos'
import { AvisosCtx } from '../useAvisos'
import { IconoCampana } from './BotonAvisos'

/**
 * La franja de arriba de la lista cuando falta activar el sonido o las
 * notificaciones: la de WhatsApp Web, «Las notificaciones están desactivadas.
 * Activar».
 *
 * El pop-up no puede venir activado —el permiso lo da cada persona en su
 * navegador— y hasta el 06-oct-2026 nada lo decía: el portal no tenía pop-up,
 * y el sonido se apagaba con una campana que no avisaba que estaba apagada.
 * «Activar» prende lo que falta y abre el panel de «Avisos» de la cabecera,
 * para que la persona vea dónde queda.
 *
 * Va DENTRO de la columna de la lista y no como franja de la pantalla: es
 * donde se mira para buscar quién escribió, y ahí no le cambia el alto al
 * chat. «Ahora no» la esconde hasta la próxima sesión y no para siempre: para
 * siempre sería volver a la campana muda, con un paso más.
 */
const CLAVE_OCULTA = 'pgh.avisos.invitacion-oculta'

function estaOculta(): boolean {
  try {
    return window.sessionStorage.getItem(CLAVE_OCULTA) === '1'
  } catch {
    return false
  }
}

export default function InvitacionAvisos() {
  const avisos = useContext(AvisosCtx)
  const [oculta, setOculta] = useState(estaOculta)
  if (!avisos?.estado || oculta) return null
  const invitacion = invitacionAActivar(avisos.estado)
  if (!invitacion) return null

  const ocultar = () => {
    setOculta(true)
    try {
      window.sessionStorage.setItem(CLAVE_OCULTA, '1')
    } catch {
      // Sin almacenamiento se esconde hasta recargar, que igual es lo pedido.
    }
  }

  return (
    <div
      role="status"
      className="flex items-start gap-2.5 border-b border-warn-border bg-warn-light px-3.5 py-2.5"
    >
      <span className="mt-0.5 flex h-[26px] w-[26px] shrink-0 items-center justify-center rounded-full bg-white text-warn">
        <IconoCampana tachada tam={14} />
      </span>
      <div className="min-w-0 flex-1">
        <p className="text-body font-bold text-warn-ink">{invitacion.titulo}</p>
        <p className="mt-0.5 text-micro text-warn-ink/90">{invitacion.detalle}</p>
        {/* «Activar» ya abre el panel de «Avisos»; «Ver dónde» queda para
            cuando no hay nada que el portal pueda prender —bloqueado en el
            navegador—. Con los tres botones no entraban en la columna. */}
        <div className="mt-1.5 flex items-center gap-3 whitespace-nowrap">
          {invitacion.boton ? (
            <button
              type="button"
              onClick={() => void avisos.activarTodo()}
              className="rounded-sm2 bg-brand px-2.5 py-1 text-micro font-bold text-white transition-colors hover:bg-brand-hover"
            >
              {invitacion.boton}
            </button>
          ) : (
            <button
              type="button"
              onClick={() => avisos.setPanelAbierto(true)}
              className="text-micro font-bold text-warn-ink underline-offset-2 hover:underline"
            >
              Ver dónde
            </button>
          )}
          <button
            type="button"
            onClick={ocultar}
            className="ml-auto text-micro text-warn-ink/80 hover:underline"
          >
            Ahora no
          </button>
        </div>
      </div>
    </div>
  )
}
